export default __webpack_public_path__ + "static/0222-b422c2fe4f95a89eba0a55cc46130692.png";